function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRespondersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 15 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.589,7.312L5.597,5.125L9.22,5.125L11.159,8.125L13.714,8.125",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(80,97,139)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.714,12.25L5.145,12.25L9.214,5.125",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(80,97,139)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.527,4.375C11.459,4.375 12.214,3.619 12.214,2.688C12.214,1.756 11.459,1 10.527,1C9.595,1 8.839,1.756 8.839,2.688C8.839,3.619 9.595,4.375 10.527,4.375Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(80,97,139)",
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.964,9.25L11.839,14.875",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(80,97,139)",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRespondersIcon);
export default __webpack_public_path__ + "static/media/Responders_icon.7bcf349861538ec19518deba50758a1c.svg";
export { ForwardRef as ReactComponent };